import axios from "axios";
import {
  toastAddErrorMessageConfig,
  toastAddSuccessMessageConfig,
  toastEditSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
} from "config/toastConfig";
import { ToastBottomEnd } from "views/components/Toast";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useFormSubmit = (
  endpoint,
  id,
  resetForm,
  setErrors,
  setIsSubmitting
) => {
  const handleSubmit = async (formData) => {
    if (!verifyTokenExpire()) return;

    setIsSubmitting(true);

    try {
      const submitData = { ...formData };

      if (id) {
        await axios.put(`${endpoint.list}/${id}`, submitData);
        ToastBottomEnd.fire(toastEditSuccessMessageConfig());
        window.location.href = "/settings/rapport-auto";
      } else {
        // delete submitData.institution_id;
        await axios.post(endpoint.list, submitData);
        resetForm();
        ToastBottomEnd.fire(toastAddSuccessMessageConfig());
      }
    } catch (error) {
      const defaultErrors = {
        institution_id: "",
        period: [],
        staffs: [],
        reporting_type: [],
      };

      setErrors({ ...defaultErrors, ...error.response?.data?.error });

      if (error.response?.status === 404) {
        ToastBottomEnd.fire(
          toastErrorMessageWithParameterConfig(error.response.data.error)
        );
      } else {
        ToastBottomEnd.fire(toastAddErrorMessageConfig());
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return { handleSubmit };
};
